import { render, staticRenderFns } from "./groupedCompactWall.vue?vue&type=template&id=ff370040&scoped=true&"
import script from "./groupedCompactWall.vue?vue&type=script&lang=js&"
export * from "./groupedCompactWall.vue?vue&type=script&lang=js&"
import style0 from "./groupedCompactWall.vue?vue&type=style&index=0&id=ff370040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff370040",
  null
  
)

export default component.exports